import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Portal from './Portal';
import Admin from './Admin';
import { colors } from './theme';

function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: colors.white,
            color: colors.darkGray,
            fontFamily: "'Avenir Next', 'Helvetica Neue', Helvetica, sans-serif",
            borderRadius: '19px',
            boxShadow: '0px 4px 14px 0px rgba(0, 99, 160, 0.15)',
          },
          success: {
            iconTheme: {
              primary: colors.success,
              secondary: colors.white,
            },
          },
          error: {
            iconTheme: {
              primary: colors.error,
              secondary: colors.white,
            },
          },
        }}
      />
      <Routes>
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/*" element={<Portal />} />
      </Routes>
    </Router>
  );
}

export default App;
